import { SubscriptionPackageResponse } from "../../api-models/response/SubscriptionPlanResponse";

export class SubscriptionPlan {
  id: number;
  name: string;
  storageSize: number;
  videoAnalyserCalls: number;
  minimumNumberOfSeats: number;
  numberOfGuestSeats: number;
  englishDescription: string;
  germanDescription: string;
  priceAmount: number;
  activeSubscriptionPackageAmount?: number;
  extraStoragePackage?: ExtraStoragePlan;
  extraVACalls?: ExtraVACallsPlan;
  extraVideoAnalysisUnitCallPrice?: number;
  sewerInspectionModule?: SewerInspectionModule;
  isPaidSubscription: boolean;
  nextBillingDate?: Date;
  unsubscribeActivationDate? : Date;
  isEnterprise? : boolean;
  previouslySelectedAmount?: number;

  constructor(
    subscriptionPlanResponse?: SubscriptionPackageResponse,
    sewerInspectionModule?: SewerInspectionModule,
    extraStoragePackage?: ExtraStoragePlan,
    extraVACalls?: ExtraVACallsPlan,
    isPaidSubscription?: boolean,
    nextBillingDate?: Date,
    unsubscribeActivationDate? : Date,
    isEnterprise? : boolean,
  ) {
    if (subscriptionPlanResponse) {
      this.id = subscriptionPlanResponse.id;
      this.name = subscriptionPlanResponse.name;
      this.storageSize = subscriptionPlanResponse.storageSize;
      this.videoAnalyserCalls = subscriptionPlanResponse.videoAnalyserCalls;
      this.minimumNumberOfSeats = subscriptionPlanResponse.minimumNumberOfSeats;
      this.numberOfGuestSeats = subscriptionPlanResponse.numberOfGuestSeats;
      this.englishDescription = subscriptionPlanResponse.englishDescription;
      this.germanDescription = subscriptionPlanResponse.germanDescription;
      this.priceAmount = subscriptionPlanResponse.priceAmount;
      this.extraStoragePackage = extraStoragePackage;
      this.extraVACalls = extraVACalls;
      this.sewerInspectionModule = sewerInspectionModule;
      this.activeSubscriptionPackageAmount =
        subscriptionPlanResponse.activeSubscriptionPackageAmount;
      this.nextBillingDate = nextBillingDate;
      this.unsubscribeActivationDate = unsubscribeActivationDate;
      this.isEnterprise = isEnterprise ?? false;
      this.isPaidSubscription = isPaidSubscription ? true : false;
      this.previouslySelectedAmount = undefined;
    } else {
      this.id = 0;
      this.name = "";
      this.storageSize = 0;
      this.videoAnalyserCalls = 0;
      this.minimumNumberOfSeats = 0;
      this.numberOfGuestSeats = 0;
      this.englishDescription = "";
      this.germanDescription = "";
      this.priceAmount = 0;
      this.extraStoragePackage = undefined;
      this.extraVACalls = undefined;
      this.activeSubscriptionPackageAmount = 0;
      this.isPaidSubscription = false;
      this.nextBillingDate = undefined;
      this.unsubscribeActivationDate = undefined;
      this.isEnterprise = false;
      this.previouslySelectedAmount = undefined;
      this.sewerInspectionModule = undefined;
    }
  }
}

export class ExtraStoragePlan {
  id: number;
  name: string;
  storageSize: number;
  englishDescription: string;
  germanDescription: string;
  priceAmount: number;
  activeSubscriptionPackageAmount?: number;
  previouslySelectedAmount?: number;

  constructor(subscriptionPlanResponse: SubscriptionPackageResponse) {
    this.id = subscriptionPlanResponse.id;
    this.name = subscriptionPlanResponse.name;
    this.storageSize = subscriptionPlanResponse.storageSize;
    this.englishDescription = subscriptionPlanResponse.englishDescription;
    this.germanDescription = subscriptionPlanResponse.germanDescription;
    this.priceAmount = subscriptionPlanResponse.priceAmount;
    this.activeSubscriptionPackageAmount = subscriptionPlanResponse.activeSubscriptionPackageAmount;
    this.previouslySelectedAmount = undefined;
  }
}

export class ExtraVACallsPlan {
  id: number;
  name: string;
  videoAnalyserCalls: number;
  englishDescription: string;
  germanDescription: string;
  priceAmount: number;
  activeSubscriptionPackageAmount?: number;
  previouslySelectedAmount?: number;

  constructor(subscriptionPlanResponse: SubscriptionPackageResponse) {
    this.id = subscriptionPlanResponse.id;
    this.name = subscriptionPlanResponse.name;
    this.videoAnalyserCalls = subscriptionPlanResponse.videoAnalyserCalls;
    this.englishDescription = subscriptionPlanResponse.englishDescription;
    this.germanDescription = subscriptionPlanResponse.germanDescription;
    this.priceAmount = subscriptionPlanResponse.priceAmount;
    this.activeSubscriptionPackageAmount = subscriptionPlanResponse.activeSubscriptionPackageAmount;
    this.previouslySelectedAmount = undefined;
  }
}
export class SewerInspectionModule {
  id: number;
  name: string;
  priceAmount: number;
  activeSubscriptionPackageAmount?: number;
  previouslySelectedAmount?: number;

  constructor(subscriptionPlanResponse: SubscriptionPackageResponse) {
    this.id = subscriptionPlanResponse.id;
    this.name = subscriptionPlanResponse.name;
    this.priceAmount = subscriptionPlanResponse.priceAmount;
    this.activeSubscriptionPackageAmount = subscriptionPlanResponse.activeSubscriptionPackageAmount;
    this.previouslySelectedAmount = undefined;
  }
}
